// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // Importă autentificarea
import { getFirestore } from "firebase/firestore"; // Importă Firestore
import {
  getDatabase,
  ref,
  get,
  child,
  query,
  orderByChild,
  equalTo,
} from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";


// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCKhnLQb3I1ubIv1sN5OHn-AciMZAgAnA4",
  authDomain: "epafa-production.firebaseapp.com",
  projectId: "epafa-production",
  storageBucket: "epafa-production.firebasestorage.app",
  messagingSenderId: "615973346913",
  appId: "1:615973346913:web:10fbe64b7029103b1f9420",
  measurementId: "G-7D0T4Q66FH",
  
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const functions = getFunctions(app, "us-central1");  // regiunea ta
const auth = getAuth(app);


// Initialize Firestore
const firestore = getFirestore(app);



// Initialize Realtime Database
const database = getDatabase(app);
const db = getFirestore(app);
export {
  firestore,
  database,
  functions,
  ref,
  get,
  child,
  query,
  orderByChild,
  equalTo,
  getDatabase,
  db,
};
export { storage };
export { app, auth };

